import Skeleton from "react-loading-skeleton"

const PlaceSkt = () => {
    return (
        <div className="tw-grid md:tw-grid-cols-2 tw-grid-cols-1 tw-gap-3">
            {
                Array(30).fill(0).map((_, index) =>
                    <div className="tw-w-full tw-flex tw-items-center tw-justify-between tw-rounded-lg tw-p-2 tw-bg-[#f8f9fa]" key={index}>
                        <div className="tw-flex tw-items-center tw-flex-col tw-gap-1 tw-justify-between">
                            <Skeleton className="tw-p-[2px] tw-w-20" />
                            <Skeleton className="tw-p-[2px] tw-w-20" />
                        </div>
                        <div className="tw-h-full tw-content-center">
                            <Skeleton className="tw-size-6" />
                        </div>
                    </div>
                )
            }
        </div>
    )
}

export default PlaceSkt